import { Button } from "design-system/atoms/Button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "design-system/atoms/Dialog"
import { SECONDS_TO_MILLIS } from "lopermut"
import { UpdateCampaignSchemaFrontend } from "modules/campaigns/hooks/useCampaignForm"
import { useCampaignQuery } from "modules/campaigns/hooks/useCampaignQuery"
import { useUpdateCampaignStatusMutation } from "modules/campaigns/hooks/useUpdateCampaignStatusMutation"
import { UseFormReturn } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { CampaignDetailResponseDataSchema, CampaignStatusEnum, LaunchCampaignSchema } from "schema"
import { toast } from "sonner"
import { z } from "zod"

type Props = {
  campaign: z.infer<typeof CampaignDetailResponseDataSchema>
  form: UseFormReturn<z.infer<typeof UpdateCampaignSchemaFrontend>>
  onClose: () => void
}

export function LaunchCampaign({ campaign, form, onClose }: Props) {
  const { t } = useTranslation()

  const { refetch } = useCampaignQuery(campaign.id)

  const { mutateAsync, isPending } = useUpdateCampaignStatusMutation(campaign.id)

  async function onLaunch() {
    await mutateAsync({
      status: CampaignStatusEnum.Active,
      campaignPayload: LaunchCampaignSchema.parse(form.getValues()),
    })
    toast.success(t("campaigns.detail.launchSuccess"))

    onClose()

    setTimeout(() => refetch(), 10 * SECONDS_TO_MILLIS)
  }

  if (!campaign) return null

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader className="flex flex-col gap-6">
          <DialogTitle>{t("campaigns.launchOthers.title")}</DialogTitle>
          <DialogDescription className="flex flex-col gap-1 text-base">
            <span>{t("campaigns.launchOthers.description")}</span>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="pt-4">
          <Button variant="secondary" onClick={onClose}>
            {t("shared.cancel")}
          </Button>
          <Button onClick={onLaunch} disabled={isPending}>
            {t("campaigns.launchOthers.launch")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
